class GiftWrapForm extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("conditional-details:closed", (e) => {
      e.target.querySelectorAll("input").forEach((input) => {
        input.value = 0;
        input.dispatchEvent(new Event("change"));
      });
    });
  }

  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();

      const formData = new FormData(this.form);

      const items = [];

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        const quantity = parseInt(value);

        if (quantity > 0) {
          items.push({
            id: name,
            quantity,
          });
        }
      }

      const onAfterAdd = () => {
        document.dispatchEvent(new CustomEvent("markup-modal:close-all"));
      };

      if (!items.length) {
        onAfterAdd();
        return;
      }

      window.addToCart(items, {
        onError: (response) => {
          this.showError(
            response?.message || window.localeStrings.product.add_to_cart_error,
          );
        },
        onAfterAdd,
      });
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }

  showError(message) {
    const error = document.createElement("div");
    error.classList.add("add-to-cart-error");
    error.innerHTML = message;

    this.form.append(error);

    setTimeout(() => {
      error.remove();
    }, 3000);
  }
}

if (!customElements.get("gift-wrap-form")) {
  customElements.define("gift-wrap-form", GiftWrapForm);
}
